/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */

import React from 'react';
import {withRouter} from 'react-router';
import {Modal, Button} from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';


class UserSelect extends React.Component {
    constructor(props) {
        console.log("[UserSelect] - initialisation");

        super(props);
        this.selectUser = this.selectUser.bind(this);
        this.onUserSelectRow = this.onUserSelectRow.bind(this);
        this.state = {
            selected : {}
        }
    }

    onUserSelectRow(row,isSelected,e) {
        var sel = this.state.selected ;
        if (isSelected) {
            sel[row.userId] = row ;
        }
        else {
            sel[row.userId] = undefined ;
        }

        this.setState({selected : sel});
        return true ;
    }


    selectUser() {
        var users = [];
        var keys = Object.keys(this.state.selected) ;
        for (var ki in keys) {
            var key = keys[ki];
            users.push(this.state.selected[key]);
        }

        this.props.onSelect(users);
    }


    render() {
        const selectRowProp = {
            mode: 'checkbox',
            bgColor: 'lightblue',
            clickToSelect: true,
            onSelect: this.onUserSelectRow
        };

        const options = {
            sortName: 'email',  // default sort column name
            sortOrder: 'asc',  // default sort order
            sizePerPage: 10,
            hideSizePerPage: true,
        };

        var userList = this.props.users || [];
        var self = this ;
        return (
            <Modal  show={true} onHide={this.props.onSelectCancelled} dialogClassName="select-user-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Select User</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <BootstrapTable data={ userList }
                        selectRow={ selectRowProp }
                        options={ options }
                        hover focus search pagination
                        tableContainerClass='orbit-table-container'>

                        <TableHeaderColumn dataField='email'  isKey >Email</TableHeaderColumn>
                        <TableHeaderColumn dataField='name' >Name</TableHeaderColumn>
                        <TableHeaderColumn dataField='role' >Role</TableHeaderColumn>
                    </BootstrapTable>
                    <br/>

                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="danger" onClick={this.props.onSelectCancelled}>Cancel</Button>
                    <Button bsStyle="success" onClick={this.selectUser}>Select</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default withRouter(UserSelect);



// WEBPACK FOOTER //
// ./src/app/components/admin/user/userSelect.js